import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { ICustoEstadia } from "../types/types";

// import { Container } from './styles';

interface Props {
  data?: ICustoEstadia;
  onClose: () => void;
  title: string;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_custo_estadia !== undefined && props.data?.id_custo_estadia !== null
                ? String(props.data.id_custo_estadia)
                : "---"}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Custo Hora
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.custo_hora !== undefined && props.data?.custo_hora !== null
                ? Number(props.data.custo_hora).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                : "---"}
            </span>
          </div>
        </div>
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Custo Meia Diária</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.custo_meia_diaria !== undefined && props.data?.custo_meia_diaria !== null
                ? Number(props.data.custo_meia_diaria).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Custo Diária</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.custo_diaria !== undefined && props.data?.custo_diaria !== null
                ? Number(props.data.custo_diaria).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                : "---"}
            </span>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Transportadora</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.razao_social
                ? props.data.razao_social
                : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Data Modificação</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Usuário</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ? props.data.usuario : "---"}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
